import React, { useState } from "react";
import FondoInteractivo from "../components/FondoInteractivo";
import { motion } from "framer-motion";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post("https://api.t-sales.cl/api/login", {
        email,
        password,
      });

      const token = response.data.access_token;

      // Guardamos token en localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      // Redirige al dashboard
      window.location.href = "/dashboard";
    } catch (err) {
      console.error(err);
      setError("Correo o contraseña incorrectos");
    }
  };

  return (
    <div className="relative w-full min-h-screen overflow-hidden flex items-center justify-center bg-[#05999c]">
      <FondoInteractivo />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative w-full max-w-md bg-white/80 shadow-2xl rounded-3xl p-10 z-10 backdrop-blur-xl"
      >
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold text-[#05999c] tracking-tight">TeleVentas</h1>
          <p className="text-gray-600 mt-2">Histórico de ventas - acceso interno</p>
        </div>

        <form className="space-y-6" onSubmit={handleLogin}>
          <div>
            <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#A5D6A7] focus:border-transparent transition-all"
              placeholder="usuario@t-sales.cl"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Contraseña</label>
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#A5D6A7] focus:border-transparent transition-all"
              placeholder="********"
              required
            />
          </div>

          <div className="text-right text-sm">
            <a href="#" className="text-[#2E7D32] hover:underline">¿Olvidaste tu contraseña?</a>
          </div>

          <motion.button
            whileTap={{ scale: 0.97 }}
            whileHover={{ scale: 1.02 }}
            type="submit"
            className="w-full bg-[#05999c] hover:bg-gray-700 text-white font-bold py-3 px-4 rounded-xl transition-all duration-300"
          >
            Iniciar Sesión
          </motion.button>
        </form>

        {error && (
          <div className="mt-4 text-center text-sm text-red-500">{error}</div>
        )}

        <div className="mt-6 text-center text-sm text-gray-500">
          T-Sales Limitada
        </div>
      </motion.div>
    </div>
  );
}
